import { ref, get, set } from "firebase/database";
import { database } from "../../../Utils/firebase";
import { generateReferralCode } from "../../../Utils/ReferralCodeGenerator";

import * as actionType from "../../../context/actions";

/**
 * Ensures a user has a referral code and updates the global mapping.
 * @param {string} userId - The user's UID.
 * @param {object} userData - The user's current data.
 * @param {function} dispatch - The global dispatch function.
 * @returns {string} - The finalized referral_code.
 */
const SyncReferralMapping = async (userId, userData, dispatch) => {
    if (!userId) return null;

    let referralCode = userData?.referral_code;

    try {
        // 1. If code is missing, generate one and update user profile
        if (!referralCode) {
            referralCode = generateReferralCode();
            console.log(`Generating new referral code for ${userId}: ${referralCode}`);
            
            await set(ref(database, `invoiceGenerator/users/${userId}/user/referral_code`), referralCode);
        }

        // 1.5 Update global state if the code is new or different from state
        if (dispatch && referralCode !== userData?.referral_code) {
            console.log(`Updating global state with referral code: ${referralCode}`);
            dispatch({
                type: actionType.SET_USER,
                payload: { ...userData, referral_code: referralCode }
            });
        }

        // 2. Map code to UID in the global referralCodes node (Checks if mapping already exists)
        if (referralCode) {
            try {
                const mappingPath = `invoiceGenerator/referralCodes/${referralCode}/uid`;
                const mappingRef = ref(database, mappingPath);
                
                const snapshot = await get(mappingRef);
                const mappingUid = snapshot.val();

                // If mapping doesn't exist or is mapped to the wrong UID, update it
                if (!mappingUid || mappingUid !== userId) {
                    console.log(`Syncing referral mapping: ${referralCode} -> ${userId} at ${mappingPath}`);
                    await set(mappingRef, userId);
                }
            } catch (mappingError) {
                // Warning only - prevents permission issues from stopping the app
                console.warn("⚠️ Referral mapping sync skipped:", mappingError.message);
            }
        }

        return referralCode;

    } catch (error) {
        console.error("SyncReferralMapping Error:", error);
        return referralCode; // return whatever we have even if mapping fails
    }
};

export default SyncReferralMapping;
